import React, { ReactElement } from 'react'
import { Flex } from '@mindfulchefuk/design-system'
import {
  DeliveryRecipe,
  RecipeWithQuantity,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeModalImage } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalImage/RecipeModalImage'
import { RecipeModalClaims } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalClaims/RecipeModalClaims'

type TRecipeModalLeftSide = {
  recipe: RecipeWithQuantity | DeliveryRecipe
}

export const RecipeModalLeftSide = ({
  recipe,
}: TRecipeModalLeftSide): ReactElement => {
  return (
    <Flex marginX="auto" direction="column" maxHeight={['none', '700px']}>
      <RecipeModalImage imgUrl={recipe.imageUrl} imgAltText={recipe.title} />
      {recipe?.claims?.length > 0 && (
        <RecipeModalClaims
          claims={recipe.claims}
          spicinessLevel={recipe.spicinessLevel}
        />
      )}
    </Flex>
  )
}
